<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
  <gt-phone-number-selector *ngIf="canEdit" fxFlex="75%"
                            (phoneNumberSelected)="selectedPhoneNumber = $event"
                            (accepted)="emittedArray($event)" 
                            [searchEndUsers]="searchEndUsers"
                            [searchContacts]="searchContacts"
                            [allowOtherNumber]="allowOtherNumber"
                            [searchMainNumbers]="searchMainNumbers"
                            [allowMultipleNums]="true"
    [oname]="orgId">
  </gt-phone-number-selector>
  <button mat-button class="btn-add" color="primary" (click)="okClicked()" [disabled]="entries.length >= maxEntries" *ngIf="canEdit">{{'global.add' | translate}}</button>
</div>

<mat-chip-list matPrefix #chipList>
  <mat-chip *ngFor="let entry of entries" [selectable]="false"
           [removable]="true" (removed)="removeEntry(entry)">
    <ng-container *ngIf="entry.name">
      {{entry.name}} ({{entry.fullNumber | phoneNumberFormatter}})
    </ng-container>
    <ng-container *ngIf="!entry.name">
      {{entry.fullNumber | phoneNumberFormatter}}
    </ng-container>
    <mat-icon *ngIf="canEdit" matChipRemove>cancel</mat-icon>
  </mat-chip>
</mat-chip-list>

